import z from "zod";
import { jwtDecode } from "jwt-decode";

const jwtUserSchema = z.object({
  email: z.string().email(),
  name: z.string(),
  org: z.string(),
  level: z.enum(["admin", "user"]),
});

export type JwtUser = z.infer<typeof jwtUserSchema>;

export function decodeJwtUser(token: string): JwtUser {
  const decoded = jwtDecode(token);
  return jwtUserSchema.parse(decoded);
}
